import React from 'react';
import '../../src/bootstrap.css';
import Introduction from '../components/Introduction'
import Plans from '../components/Plans'
import Testimonial from '../components/Testimonial'
import Footer from '../components/Footer'



const Home = () => {
 return (
  <>

   <Introduction  />
   <Plans />
   <Testimonial />
   {/* <Cards /> */}
   
  </>
 )
}

export default Home